var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styles from '@web/components/layout/Loading/Loading.module.css';
import { classNames } from '@web/utility';
var Loading = function (_a) {
    var className = _a.className, spinnerClassName = _a.spinnerClassName;
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: classNames('top-0 left-0 right-0 bottom-0 w-full h-60 z-1 overflow-hidden opacity-75 flex flex-col items-center justify-center', className) }, { children: _jsx("div", { className: classNames('ease-linear rounded-full border-4 border-transparent border-t-4 h-12 w-12 mb-4', styles.loader, spinnerClassName) }) })) }));
};
export default Loading;
